import { render } from "./EmployeesLists.vue?vue&type=template&id=9b0ad0a6&scoped=true"
import script from "./EmployeesLists.vue?vue&type=script&lang=js"
export * from "./EmployeesLists.vue?vue&type=script&lang=js"

import "./EmployeesLists.vue?vue&type=style&index=0&id=9b0ad0a6&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0ad0a6"]])

export default __exports__